/**
 * Ubah alamat yang tertulis sebagai teks biasa menjadi tautan yang bisa diklik.
 *
 * Isi pengumuman ditulis di editor CMS, dan penulisnya sering sekadar menempel
 * alamat ("https://forms.gle/..." atau "ptsp.kemenlh.go.id") tanpa menjadikannya
 * tautan. Di layar pembaca alamat itu lalu harus disalin manual.
 *
 * Penelusuran dilakukan pada SIMPUL TEKS lewat DOMParser, bukan dengan
 * mengganti-ganti string HTML: kalau dikerjakan pada string mentah, alamat yang
 * sudah berada di dalam <a href="..."> ikut tergantikan dan tautannya rusak
 * bersarang. Simpul yang sudah berada di dalam <a> sengaja dilewati.
 */

// Diakhiri kelompok tanpa tanda baca supaya titik atau koma penutup kalimat
// tidak ikut terbawa ke dalam alamat.
const POLA_ALAMAT = /((?:https?:\/\/|www\.)[^\s<>"']+[^\s<>"'.,;:!?)\]]|(?:[a-z0-9-]+\.)+(?:go\.id|co\.id|or\.id|ac\.id|id|com|net|org)(?:\/[^\s<>"']*[^\s<>"'.,;:!?)\]])?)/gi;

function alamatLengkap(teks) {
  return /^https?:\/\//i.test(teks) ? teks : `https://${teks}`;
}

export function jadikanTautan(html) {
  if (!html || typeof html !== "string") return html;

  try {
    const dokumen = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
    const akar = dokumen.body.firstChild;

    const penelusur = dokumen.createTreeWalker(akar, NodeFilter.SHOW_TEXT);
    const simpulTeks = [];
    while (penelusur.nextNode()) simpulTeks.push(penelusur.currentNode);

    simpulTeks.forEach((simpul) => {
      if (simpul.parentElement?.closest("a")) return;

      const teks = simpul.nodeValue;
      POLA_ALAMAT.lastIndex = 0;
      if (!POLA_ALAMAT.test(teks)) return;

      POLA_ALAMAT.lastIndex = 0;
      const pecahan = dokumen.createDocumentFragment();
      let posisi = 0;
      let cocok;

      while ((cocok = POLA_ALAMAT.exec(teks)) !== null) {
        if (cocok.index > posisi) {
          pecahan.appendChild(dokumen.createTextNode(teks.slice(posisi, cocok.index)));
        }

        const tautan = dokumen.createElement("a");
        tautan.setAttribute("href", alamatLengkap(cocok[0]));
        tautan.setAttribute("target", "_blank");
        tautan.setAttribute("rel", "noopener noreferrer");
        tautan.textContent = cocok[0];
        pecahan.appendChild(tautan);

        posisi = cocok.index + cocok[0].length;
      }

      if (posisi < teks.length) {
        pecahan.appendChild(dokumen.createTextNode(teks.slice(posisi)));
      }

      simpul.parentNode.replaceChild(pecahan, simpul);
    });

    return akar.innerHTML;
  } catch (galat) {
    // Kalau apa pun gagal, isi aslinya dikembalikan apa adanya - lebih baik
    // alamat tidak bisa diklik daripada pengumumannya hilang dari layar.
    return html;
  }
}

export default jadikanTautan;
